import { render, staticRenderFns } from "./SysParaEdit.vue?vue&type=template&id=6bbd3dcc&"
import script from "./SysParaEdit.vue?vue&type=script&lang=js&"
export * from "./SysParaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports